<template>
  <RisksContentContainerWrapper
    v-if="
      evacuation && evacuation.title && (evacuation.body || evacuation.level)
    "
    class="pa-3"
    wrapper-id="risks-evacuation"
    :reset-expanded="resetExpanded"
    @click-expand="handleClickExpand"
  >
    <v-card flat>
      <div class="hyp-risk-content-container">
        <div class="details-heading application-heading mb-4">
          {{ evacuation.title }}
        </div>
        <v-row v-if="evacuation.body">
          <v-col cols="12" class="pt-0 content-container">
            <v-card
              flat
              outlined
              color="transparent"
              ref="bodyEvacuation"
              v-html="getCleanBody(evacuation.body)"
              class="mt-0 pt-0"
            >
            </v-card>
          </v-col>
        </v-row>
        <RisksEvacuationLevel
          v-if="evacuation && evacuation.level && !evacuation.body"
          :background="background"
          evac-class="hyp-risk-evacuation-level my-n2"
        ></RisksEvacuationLevel>
      </div>
    </v-card>
  </RisksContentContainerWrapper>
</template>

<script>
import lodashGet from "lodash/get";

import {
  addTargetToLinks,
  addCardMoreLess,
  cleanUpAddCardMoreLessEvents,
} from "@/common/basic.utilities";

export default {
  name: "RisksEvacuation",
  components: {
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    RisksEvacuationLevel: () =>
      import("@/components/controlRisks/risks/RisksEvacuationLevel"),
  },
  props: {
    background: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      resetExpanded: null,
    };
  },
  computed: {
    evacuation() {
      if (lodashGet(this.background, "properties.formatted.evacuation")) {
        let evacuationInfo = this.background.properties.formatted.evacuation;
        evacuationInfo.level = lodashGet(
          this.background,
          "properties.formatted.evacuationLevel"
        );
        return evacuationInfo;
      }
      return null;
    },
  },
  methods: {
    handleClickExpand(wrapperId, expandedYN) {
      if (wrapperId == "risks-evacuation") {
        if (expandedYN) {
          const showMore = this.$refs["bodyEvacuation"].$el.querySelector(
            ".show-more"
          );
          if (showMore) {
            showMore.click();
          }
        } else {
          const showLess = this.$refs["bodyEvacuation"].$el.querySelector(
            ".show-less"
          );
          if (showLess) {
            showLess.click();
          }
        }
      }
    },
    getCleanBody(body) {
      if (body) {
        return addTargetToLinks(body);
      }
      return "";
    },
  },
  watch: {
    background: {
      handler() {
        addCardMoreLess(this.$refs, "bodyEvacuation");
        this.resetExpanded = new Date().toISOString();
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    cleanUpAddCardMoreLessEvents();
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.content-container {
  max-width: 550px !important;
  font-size: 14px;
}
.hyp-risk-grid .content-container {
  max-width: unset !important;
}
.hyp-risks-content-expanded .hyp-risk-content-container {
  max-width: 50vw;
  margin: 12px auto;
}
</style>
